// Shared pieces of the menu-test table shaping, ported from the ItemsListView base and the
// mn items-list views (header subtitle variants, clickable resolution, sorted-column marking).

import { formatAmounts } from '@aytm/app/stats/lib/util/helpers'

export const answerHasBase = answer =>
  Object.hasOwn(answer, 'base') ||
  Object.keys(answer).some(key => null != answer[key] && Object.hasOwn(answer[key], 'base'))

export const formatHidesTotal = format => Object.hasOwn(format || {}, 'hideTotal') && true === format.hideTotal

// response-count subtitle for the metric-column headers: "(based on N responses)" when the
// answer carries a base, otherwise the metric name plus "(from N resp.)" unless hidden
export const buildHeaderTitle = ({ answer, format }) => {
  const hasBase = answerHasBase(answer)
  const totalSubtitle =
    (!formatHidesTotal(format) && `<small>(from ${formatAmounts(answer?.total || 0)} resp.)</small>`) || ''
  const baseSubtitle = `<small>(based on ${formatAmounts(answer, ['base', 'total'])} responses)</small>`

  return columnName => (hasBase ? baseSubtitle : `${columnName}${totalSubtitle}`)
}

// format.clickable wins, then the view option, then the base default (ItemsListView.clickable)
export const resolveClickable = ({ format, viewClickable }) => {
  if (undefined !== format?.clickable) return format.clickable
  if (undefined !== viewClickable) return viewClickable
  return true
}

// ItemsListView.calcSortedIndex port: marks the sorted column in place. One approved deviation
// from the coffee base: an undefined sortOrder (the D5 unrecognised-token wart) crashed the
// coffee items-list render — in the single React block that throw would take the whole mount
// down, so it resolves to "no sorted column" instead.
export const calcSortedIndex = (cols, sortOrder) => {
  if (null == sortOrder) {
    for (const col of cols) delete col.sorted
    return cols
  }

  const sortOrderParts = sortOrder.split('-')

  let colIndex
  if (1 < sortOrderParts.length) {
    colIndex = cols.findIndex(col => col.param === sortOrderParts[0])
  } else {
    const colType = ('i' === sortOrder[0] && 'title') || ('v' === sortOrder[0] && 'progress')
    colIndex = cols.findIndex(col => colType === col.type)
  }
  if (0 > colIndex) colIndex = cols.length - 1

  for (const col of cols) delete col.sorted
  cols[colIndex].sorted =
    2 === sortOrderParts.length ? ('asc' === sortOrderParts[1] && 1) || -1 : ('asc' === sortOrder.slice(1) && 1) || -1

  return cols
}
